<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/subprogram' }">
        <app-i18n code="entities.subprogram.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.subprogram.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.subprogram.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-subprogram-view-toolbar v-if="record"></app-subprogram-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <!-- Step 1 **************************************************************************************** -->
        <!-- id -->
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>
        <!-- name -->
        <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>
        <!-- type -->
        <!-- <app-view-item-text :label="fields.type.label" :value="presenter(record, 'type')"></app-view-item-text> -->
        <!-- category -->
        <app-view-item-relation-to-one
          :label="fields.category.label"
          :permission="fields.category.readPermission"
          :url="fields.category.viewUrl"
          :value="presenter(record, 'category')"
        ></app-view-item-relation-to-one>
        <!-- start date -->
        <app-view-item-text :label="fields.startDate.label" :value="presenter(record, 'startDate')"></app-view-item-text>
        <!-- end date -->
        <app-view-item-text :label="fields.endDate.label" :value="presenter(record, 'endDate')"></app-view-item-text>

        <app-view-item-custom
          :label="fields.subprogramDays.label"
          :value="presenter(record, 'subprogramDays')"
        >
          <div :key="day" v-for="day in record.subprogramDays">
            <el-tooltip :content="subprogramDaysDescriptionOf(day)">
              <span>{{ subprogramDaysLabelOf(day) }}</span>
            </el-tooltip>
          </div>
        </app-view-item-custom>
        <!-- Step 2 **************************************************************************************** -->
        <!-- gender -->
        <app-view-item-text :label="fields.gender.label" :value="presenter(record, 'gender')"></app-view-item-text>
        <!-- season -->
        <!-- <app-view-item-relation-to-one
          :label="fields.season.label"
          :permission="fields.season.readPermission"
          :url="fields.season.viewUrl"
          :value="presenter(record, 'season')"
        ></app-view-item-relation-to-one>-->
        <!-- locations -->
        <app-view-item-relation-to-one
          :label="fields.locations.label"
          :permission="fields.locations.readPermission"
          :url="fields.locations.viewUrl"
          :value="presenter(record, 'locations')"
        ></app-view-item-relation-to-one>
        <!-- Step 3 **************************************************************************************** -->

        <!-- Step 4 **************************************************************************************** -->
        <!-- registration start date -->

        <!-- managers-->
        <app-view-item-relation-to-many
          :label="fields.managers.label"
          :permission="fields.managers.readPermission"
          :url="fields.managers.viewUrl"
          :value="presenter(record, 'managers')"
        ></app-view-item-relation-to-many>
        <!-- emails-->
        <app-view-item-text :label="fields.emails.label" :value="presenter(record, 'emails')"></app-view-item-text>
        <!-- status -->
        <app-view-item-custom :label="fields.status.label" :value="presenter(record, 'status')">
          <el-tag :type="propertyStatusTagType(record['status'])">{{ presenter(record, 'status') }}</el-tag>
        </app-view-item-custom>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SubprogramViewToolbar from '@modules/subprogram/components/subprogram-view-toolbar.vue';
import { SubprogramModel } from '@modules/subprogram/subprogram-model';
import SubprogramDaysModel from '@modules/subprogram/subprogram-days-model';
import { propertyStatusTagType } from '@modules/property/property-enum-status';
import { propertyAccessTagType } from '@modules/property/property-enum-access';

export default {
  name: 'app-subprogram-view-page',

  props: ['id'],

  components: {
    [SubprogramViewToolbar.name]: SubprogramViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'subprogram/view/record',
      loading: 'subprogram/view/loading',
      dateFormat: 'auth/manage/dateFormat',
      populateDate: 'auth/manage/populateDate',
    }),

    fields() {
      const { dateFormat, populateDate } = this;
      return new SubprogramModel({
        dateFormat,
        populateDate,
      }).fields();
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'subprogram/view/doFind',
    }),

    presenter(record, fieldName) {
      const { dateFormat, populateDate } = this;

      return new SubprogramModel({
        dateFormat,
        populateDate,
      }).presenter(record, fieldName);
    },

    subprogramDaysDescriptionOf(subprogramId) {
      return SubprogramDaysModel.descriptionOf(
        subprogramId,
      );
    },

    subprogramDaysLabelOf(subprogramId) {
      return SubprogramDaysModel.labelOf(subprogramId);
    },

    propertyStatusTagType(status) {
      return propertyStatusTagType(status);
    },

    propertyAccessTagType(status) {
      return propertyAccessTagType(status);
    },
  },
};
</script>
